export default {
    groupName: 'comcast-offer',
    appName: 'Comcast Offer',
    baseRoute: '/dashboard/comcast-offer',
    label: 'Offer Tracker Dashboard',
    home: '/slicer',
    image: 'comcast.png',
    description: 'Comcast Offer Tracker Dashboard'
}
